const bodyMeasurementsData = [
    {
        key: 'neckMC',
        name: '頸圍',
        unit: 'cm',
        deltaValueKey: 'deltaNeckMC',
    },
    {
        key: 'chestMC',
        name: '胸圍',
        unit: 'cm',
        deltaValueKey: 'deltaChestMC',
    },
    {
        key: 'abdomenMC',
        name: '腹圍',
        unit: 'cm',
        deltaValueKey: 'deltaAbdomenMC',
    },
    {
        key: 'hipMC',
        name: '臀圍',
        unit: 'cm',
        deltaValueKey: 'deltaHipMC',
    },
    {
        key: 'rightArmMC',
        name: '右臂',
        unit: 'cm',
        deltaValueKey: 'deltaRightArmMC',
    },
    {
        key: 'leftArmMC',
        name: '左臂',
        unit: 'cm',
        deltaValueKey: 'deltaLeftArmMC',
    },
    {
        key: 'rightThighMC',
        name: '右大腿',
        unit: 'cm',
        deltaValueKey: 'deltaRightThighMC',
    },
    {
        key: 'leftThighMC',
        name: '左大腿',
        unit: 'cm',
        deltaValueKey: 'deltaLeftThighMC',
    },
];

export default bodyMeasurementsData;
